import { api } from '.'
import { startAuthentication, startRegistration } from '@simplewebauthn/browser'

export async function getPasskeys () {
	const response = await api.get('/passkeys')
	return response.data
}

export async function registerPasskey (password, name) {
	const begin = await api.post('/passkeys/register/begin', { Password: password })
	const credential = await startRegistration({ optionsJSON: begin.data.Data.Options })
	const response = await api.post('/passkeys/register/finish', {
		CeremonyID: begin.data.Data.CeremonyID,
		Name: name,
		Credential: credential
	})
	return response.data
}

export async function removePasskey (id, password) {
	const response = await api.post('/passkeys/' + id + '/remove', { Password: password })
	return response.data
}

export async function signinWithPasskey (useBrowserAutofill, isCurrent) {
	const begin = await api.post('/signin/passkey/begin')
	// Starting would abort the ceremony of a newer attempt.
	if (!isCurrent()) {
		throw new DOMException('A newer passkey sign-in has started', 'AbortError')
	}
	const credential = await startAuthentication({
		optionsJSON: begin.data.Data.Options,
		useBrowserAutofill
	})
	const response = await api.post('/signin/passkey/finish', {
		CeremonyID: begin.data.Data.CeremonyID,
		Credential: credential
	})
	return response.data
}
